import { render, staticRenderFns } from "./present.vue?vue&type=template&id=813fd3ba"
import script from "./present.vue?vue&type=script&lang=js"
export * from "./present.vue?vue&type=script&lang=js"
import style0 from "./present.vue?vue&type=style&index=0&id=813fd3ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports